import * as React from "react"
import styles from "../../../styles/components/Product/Disclaimer/Disclaimer-tw-styles"
import RichText from "../RichText/Richtext"
import PropTypes from "prop-types" 

const Disclaimer = ({ content, theme, classKey }) => {
    const { disclaimer, text, black } = styles
    return (
        <div className={`${disclaimer} ${theme ? styles[theme] : black} ${classKey ? classKey : ""}`}>
            <RichText className={text} richTextJson={content}/>
        </div>
    )
}
Disclaimer.propTypes={
    content: PropTypes.object,
    theme:PropTypes.string,
    classKey:PropTypes.string,
   
}
export default Disclaimer
